import "./style.less";
import type { PortalDesktopProps } from "./types";

export function PortalDesktop({ links }: PortalDesktopProps) {
  const names = Object.keys(links);

  if (names.length === 0) {
    return <></>;
  }

  return (
    <table border={1} className="PortalDesktop-component">
      <thead>
        <tr>
          <th>Nome da rádio</th>
          <th>
            Recomendado
            <br />
            Full
          </th>
          <th>
            Alternativo
            <br />
            Full
          </th>
          <th>
            Recomendado
            <br />
            Lite
          </th>
          <th>
            Alternativo
            <br />
            Lite
          </th>
        </tr>
      </thead>
      <tbody>
        {names.map((name) => (
          <tr key={name}>
            <th>{name}</th>
            <td>
              <a href={links[name].recommended} target="_blank">
                Link
              </a>
            </td>
            <td>
              <a href={links[name].alternative} target="_blank">
                Link
              </a>
            </td>
            <td>
              <a href={links[name].recommended_lite} target="_blank">
                Link
              </a>
            </td>
            <td>
              <a href={links[name].alternative_lite} target="_blank">
                Link
              </a>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
